/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Heading from 'components/heading';
import Expander from 'components/expander';
import HousingProjectContactCardContent from './housing-project-contact-card-content';

const baseThemes = { dark: 'dark', light: 'light' };

const HousingProjectContactCard = ({ title, content, baseTheme }) => (
  <div
    className={cn('housing-project-contact-card', {
      [`housing-project-contact-card--${baseTheme}`]: baseTheme
    })}
  >
    <div
      className={cn(
        'housing-project-contact-card__content',
        'housing-project-contact-card__content--desktop-only'
      )}
    >
      {title && (
        <Heading
          level={2}
          theme={Heading.themes.h3PortalBold}
          className="housing-project-contact-card__header"
        >
          {title}
        </Heading>
      )}
      <HousingProjectContactCardContent {...content} />
    </div>

    <div
      className={cn(
        'housing-project-contact-card__content',
        'housing-project-contact-card__content--mobile-only'
      )}
    >
      <Expander title={title} color={baseTheme} theme="plusminus">
        <HousingProjectContactCardContent {...content} />
      </Expander>
    </div>
  </div>
);

HousingProjectContactCard.propTypes = {
  title: PropTypes.string,
  baseTheme: PropTypes.oneOf(Object.values(baseThemes)),
  content: PropTypes.exact(HousingProjectContactCardContent.propTypes)
};

HousingProjectContactCard.defaultProps = {
  baseTheme: baseThemes.light
};

HousingProjectContactCard.propTypesMeta = { baseTheme: 'exclude' };

export default HousingProjectContactCard;
